import { createSlice } from "@reduxjs/toolkit";
import { fetchRFQLogs } from "./thunk";

interface PRState {
  list: any[];
  rowCount: number;
  loading: boolean;
  error: string | null;
}

const initialState: PRState = {
  list: [],
  rowCount: 0,
  loading: false,
  error: null,
};

const rfqLogSlice = createSlice({
  name: "RFQ Log",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchRFQLogs.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(fetchRFQLogs.fulfilled, (state, action) => {
        state.loading = false;
        state.list = action.payload.data;
        state.rowCount = action.payload.rowCount;
      })
      .addCase(fetchRFQLogs.rejected, (state, action) => {
        state.loading = false;
        state.error = action.error.message || "Failed to fetch RFQ Log List";
      });

  },
});

export default rfqLogSlice.reducer;
